/*
* Created on Mar 05, 2021
* @author: Adam Cheng <adamcheng@qnap.com>
*/
import {useCallback, useEffect, useRef, useState} from 'react';
import ModalComponent from "../../common/ModalComonent/ModalComponent";
import TextInputComponent from "../../common/Form/TextInputComponent";
import SelectInputComponent from "../../common/Form/SelectInputComponent";
import {DEFAULT_SIZE_LIST, isValidCountry} from "../../../service/common";
import {useCountryList} from "../../../context/CountryListContext";
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';
import {useTranslation} from "react-i18next";
import {useOrganizationApi} from "../../../hook/OrganizationAPIHook";
import CountrySelectComponent from "../../common/Form/CountrySelectComponent";
import {useOrganizationListRefresh} from "../../../context/OrganizationContext";


const OrganizationEditModelComponent = ({openModal, closeModal, organization, setOrgList}) => {
    const {t} = useTranslation();
    const {OrganizationAPI} = useOrganizationApi();
    const {list: countryList} = useCountryList();
    const init_input = {
        name: {value: organization.name || '', error: null, required: true},
        country: {value: organization.country || '', error: null, required: true},
        size: {value: organization.size || '', error: null, required: false},
        website: {value: organization.website || '', error: null, required: false},
        phone: {value: organization.phone || '', error: null, required: false},
    }

    const uploadFile = useRef(null);
    const modal = useRef();
    const [avatarImage, setAvatarImage] = useState();
     const [crop, setCrop] = useState({
        unit: '%', // Can be 'px' or '%'
        width: 100,
        height: 100});
    const [completedCrop, setCompletedCrop] = useState(null);
    const imgRef = useRef(null);
    const [formData, setFormData] = useState(new FormData());
    const [showImageCrop, setShowImageCrop] = useState('hide');

    const [input, setInput] = useState(init_input);

    const [showUpload, setShowUpload] = useState(false);
    const [showUploading, setShowUploading] = useState(false);
    const {setRefresh:refreshOrganizationList} = useOrganizationListRefresh();

    const onOpenFileUpload = () => {
        uploadFile.current.click();
    }

    const openAvatarUploadInput = () => {
        setShowUpload(true);
        modal.current.setSubmitText(t('@Upload@'));
        setInput((prev)=>{
            return {...prev, upload_image: {value: null, required: true}}
        })
    }

    const onFileChange = (e) => {
        e.stopPropagation();
        e.preventDefault();
        const file = uploadFile.current.files[0];
        setAvatarImage(URL.createObjectURL(file));
        console.log(file);

        const _form = new FormData();
        _form.append('avatar_file', uploadFile.current.files[0]);
        setFormData(_form);
        setInput(prev=>{
            delete prev['upload_image'];
            return {...prev};
        });
    }

    const onLoad = useCallback((img) => {
        imgRef.current = img;
        setInput(prev=>{
            delete prev['upload_image'];
            return {...prev};
        });
    }, []);

    const onImageLoaded = (c) => {
        console.log(c);
        setCrop(c);
        setInput(prev=>{
            delete prev['upload_image'];
            return {...prev};
        });
    }

    const uploadAvatar = async (formData) => {
        const result = await OrganizationAPI.upload(`organization/${organization.organization_id}/avatar`, formData);
        console.log(result);
        // const org = await OrganizationAPI.get(`organization/${organization.organization_id}`);
        const avatars = {
            cn: {
                icon: `${window._env_.REACT_APP_ORGANIZATION_API_URL_CN}/avatar/org/${organization.organization_id}/i`,
                medium: `${window._env_.REACT_APP_ORGANIZATION_API_URL_CN}/avatar/org/${organization.organization_id}/m`,
                small: `${window._env_.REACT_APP_ORGANIZATION_API_URL_CN}/avatar/org/${organization.organization_id}/s`,
            },
            icon: `${window._env_.REACT_APP_ORGANIZATION_API_URL}/avatar/org/${organization.organization_id}/i`,
            medium: `${window._env_.REACT_APP_ORGANIZATION_API_URL}/avatar/org/${organization.organization_id}/m`,
            small: `${window._env_.REACT_APP_ORGANIZATION_API_URL}/avatar/org/${organization.organization_id}/s`
        }
        setOrgList((prev) => {
            return prev.map(o => o.organization_id === organization.organization_id ? {...o, avatars} : o);
        });
        setShowUpload(false);
        modal.current.setSubmitText(t('@Update@'));
        // setRefresh((prev)=> prev+1);
    }

    const onCancel = () => {
        if (showUpload) {
            setShowUpload(false);
            modal.current.setSubmitText('@Update@');
        }
        else {
            closeModal(false)
        }
    }

    const onSubmit = async () => {
        if (showUpload) {
            setShowUploading(true);
            await uploadAvatar(formData);
            setShowUploading(false);
        }
        else {
            // do update org
            const input_data = {}
            for ( const [key, value] of Object.entries(input) ) {
                if (value.value) {
                    input_data[key] = value.value
                }
            }
            if (!isValidCountry(input_data.country, countryList)) {
                setInput(prev => ({
                    ...prev,
                    country: {
                        ...prev.country,
                        error: t('@Invalid country@'),
                    },
                }));
                return;
            }
            await OrganizationAPI.put(`organization/${organization.organization_id}`, null, input_data);
            setOrgList((prev) => {
                return prev.map(o => o.organization_id === organization.organization_id ? {...o, ...input_data} : o);
            });
            refreshOrganizationList(prev => prev + 1);
            closeModal()
            // console.log(input_data);
            // setOrganization((prev)=> {return {...prev, ...input}});
            // setRefresh((prev)=> prev+1);
        }
    }

    useEffect(() => {
        if (!completedCrop) return;
        const scaleX = imgRef.current.naturalWidth / imgRef.current.width;
        const scaleY = imgRef.current.naturalHeight / imgRef.current.height;
        const cords = {
            x: completedCrop.x * scaleX,
            y: completedCrop.y * scaleY,
            width: completedCrop.width * scaleX,
            height: completedCrop.height * scaleY
        }
        console.log(cords)
        const _form = new FormData();
        _form.append('avatar_file', uploadFile.current.files[0]);
        _form.append('origin_w', Math.floor(cords.width));
        _form.append('origin_h', Math.floor(cords.height));
        _form.append('x1', Math.floor(cords.x));
        _form.append('y1', Math.floor(cords.y));
        setFormData(_form);

    }, [completedCrop]);

    useEffect(()=>{
        if (avatarImage) {
            setShowImageCrop('');
        }
        else {
            setShowImageCrop('hide');
        }
    }, [avatarImage]);

    return (
        <ModalComponent isOpen={openModal} onClose={onCancel} onSubmit={async ()=> await onSubmit()} title={t('@Edit organization@')} okText={t('@Update@')} input={input} ref={modal} onError={()=>setShowUploading(false)}>
            <div className="org-avatar-group">
                <div className="org-avatar">
                    <div className={`avatar ${organization.avatars ? '' : 'no-avatar'}`}>
                        {organization.avatars ? <img src={`${organization.avatars.medium}?t=${new Date().getTime()}`} alt=""/> :
                            <span>{organization.name[0]}</span>}
                    </div>
                </div>
                <div className="org-avatar-upload">
                    <button type="button" className="q-btn q-btn-default q-btn-round-corner" onClick={openAvatarUploadInput}>{t('@Upload photo@')}</button>
                </div>
            </div>

            <div className="dialog-content">
                {/* Uploading indicator */}
                {showUploading &&
                    <div className="dialog-loading-wrapper">
                        <div className="q-loading-indicator">
                            <div className="indicator-anime">
                                <div className="dash dash-1"></div>
                                <div className="dash dash-2"></div>
                                <div className="dash dash-3"></div>
                                <div className="dash dash-4"></div>
                            </div>
                            <div className="indicator-content">
                                <div className="indicator-label">
                                    <span className="text">{t('@Loading@')}...</span>
                                </div>
                            </div>
                        </div>
                    </div>
                }

                <div className={showUpload ? '' : 'hide'}>
                    {/*<div*/}
                    {/*    className="text-wrap display-flex align-items-center align-items-center align-content-center !mb-8">*/}
                    {/*    <span className="!mr-8">{t('@If you have a QNAP Profile picture then it is always visible to everyone.@')}</span>*/}
                    {/*    <a href="#" className="color-blue" onClick={e=>{e.preventDefault(); setShowUpload(false)}}>{t('@Cancel Upload@')}</a>*/}
                    {/*</div>*/}
                    <div className="avatar-update">
                        <div className={`avatar-section ${showImageCrop}`}>
                            <ReactCrop crop={crop} onChange={c => onImageLoaded(c)} onComplete={c => setCompletedCrop(c)} aspect={1}>
                                <img src={avatarImage} alt="" ref={imgRef}/>
                            </ReactCrop>
                        </div>
                        <div className="browse-file">
                            <button type="button" className="q-btn q-btn-default q-btn-round-corner" onClick={onOpenFileUpload}>{t('@Select from computer@')}</button>
                            <input type='file' ref={uploadFile} className='hide' onChange={(e)=>onFileChange(e)}/>
                            <div className="text-note fs13 !mt-16 text-align-center">{t('@Maximum upload file size: {{maxFileSize}} MB@', {maxFileSize: 5})}</div>
                        </div>
                    </div>
                </div>

                <div className={showUpload ? 'hide' : ''}>
                    <form>
                        <TextInputComponent label={t('@Organization name@')} field_name={'name'} input={input} setInput={setInput} place_holder={t('@Please input your organization name@')} />
                        {/*<SelectInputComponent label={t('@Country@')} field_name={'country'} input={input} setInput={setInput} listData={DEFAULT_COUNTRY_LIST} useLocale={true} empty_text={t('@Please select your organization country@')} useSearch={true}/>*/}
                        <CountrySelectComponent field_name={'country'} input={input} setInput={setInput} useLocale={true} empty_text={t('@Please select your organization country@')} useSearch={true}/>
                        <SelectInputComponent label={t('@Organization size@')} field_name={'size'} input={input} setInput={setInput} listData={DEFAULT_SIZE_LIST} useLocale={false} empty_text={t('@Please select a approximate number of members in your organization@')} />
                        <TextInputComponent label={t('@Organization website@')} field_name={'website'} input={input} setInput={setInput} place_holder={t('@Please provide official website of your organization@')} />
                        <TextInputComponent label={t('@Organization phone number@')} field_name={'phone'} input={input} setInput={setInput} place_holder={t('@Please provide contact number of your organization@')} />
                    </form>
                </div>
            </div>
        </ModalComponent>
    );
};

export default OrganizationEditModelComponent;